// Field types: text, tel, email, number, radio, yesno, textarea
// Each field: { name, type, fr, en, required?, options?, colSpan?, prefix? }

export const STEPS = [
  {
    number: 1,
    fr: "Identification & Statut",
    en: "Identification & Status",
    groups: [
      {
        fr: "Coordonnées", en: "Contact information",
        fields: [
          { name: "prenom", type: "text", fr: "Prénom", en: "First name", required: true },
          { name: "nom", type: "text", fr: "Nom", en: "Last name", required: true },
          { name: "ni", type: "text", fr: "NI (Numéro d'identification)", en: "ID number", required: true },
          { name: "courriel", type: "email", fr: "Courriel", en: "Email", required: true },
          { name: "telephone", type: "tel", fr: "Téléphone", en: "Phone" },
          { name: "adresse", type: "text", fr: "Adresse postale", en: "Postal address", colSpan: 2 },
          { name: "appartement", type: "text", fr: "N° d'appartement", en: "Apartment #" },
          { name: "ville", type: "text", fr: "Ville", en: "City" },
          { name: "code_postal", type: "text", fr: "Code postal", en: "Postal code" },
        ],
      },
      {
        fr: "Études", en: "Studies",
        fields: [
          {
            name: "faculte", type: "combobox", fr: "Faculté", en: "Faculty", required: true, colSpan: 2,
            options: [
              { value: "Aménagement, architecture, art et design (FAAAD)", fr: "Aménagement, architecture, art et design (FAAAD)", en: "Aménagement, architecture, art et design (FAAAD)" },
              { value: "Droit (FD)", fr: "Droit (FD)", en: "Droit (FD)" },
              { value: "Études supérieures et postdoctorales (FESP)", fr: "Études supérieures et postdoctorales (FESP)", en: "Études supérieures et postdoctorales (FESP)" },
              { value: "Foresterie, géographie et géomatique (FFGG)", fr: "Foresterie, géographie et géomatique (FFGG)", en: "Foresterie, géographie et géomatique (FFGG)" },
              { value: "Lettres et sciences humaines (FLSH)", fr: "Lettres et sciences humaines (FLSH)", en: "Lettres et sciences humaines (FLSH)" },
              { value: "Médecine (FMED)", fr: "Médecine (FMED)", en: "Médecine (FMED)" },
              { value: "Médecine dentaire (FMD)", fr: "Médecine dentaire (FMD)", en: "Médecine dentaire (FMD)" },
              { value: "Musique (FMUS)", fr: "Musique (FMUS)", en: "Musique (FMUS)" },
              { value: "Pharmacie (FPHA)", fr: "Pharmacie (FPHA)", en: "Pharmacie (FPHA)" },
              { value: "Philosophie (FP)", fr: "Philosophie (FP)", en: "Philosophie (FP)" },
              { value: "Sciences de l'administration (FSA)", fr: "Sciences de l'administration (FSA)", en: "Sciences de l'administration (FSA)" },
              { value: "Sciences de l'agriculture et de l'alimentation (FSAA)", fr: "Sciences de l'agriculture et de l'alimentation (FSAA)", en: "Sciences de l'agriculture et de l'alimentation (FSAA)" },
              { value: "Sciences de l'éducation (FSE)", fr: "Sciences de l'éducation (FSE)", en: "Sciences de l'éducation (FSE)" },
              { value: "Sciences de l'ingénierie (FSG)", fr: "Sciences de l'ingénierie (FSG)", en: "Sciences de l'ingénierie (FSG)" },
              { value: "Sciences infirmières (FSI)", fr: "Sciences infirmières (FSI)", en: "Sciences infirmières (FSI)" },
              { value: "Sciences sociales (FSS)", fr: "Sciences sociales (FSS)", en: "Sciences sociales (FSS)" },
              { value: "Théologie et sciences religieuses (FTSR)", fr: "Théologie et sciences religieuses (FTSR)", en: "Théologie et sciences religieuses (FTSR)" },
              { value: "autre", fr: "Autre (Saisie manuelle)", en: "Other (manual entry)" },
            ],
          },
          {
            name: "faculte_autre", type: "text", required: true, colSpan: 2,
            fr: "Précisez votre faculté", en: "Specify your faculty",
            showIf: { field: "faculte", value: "autre" },
          },
          { name: "programme", type: "text", fr: "Programme", en: "Program", required: true, colSpan: 2 },
          {
            name: "cycle", type: "select", fr: "Cycle d'études", en: "Study cycle", required: true, colSpan: 2,
            options: [
              { value: "1er cycle (Baccalauréat, Certificat, Majeure/Mineure)", fr: "1er cycle (Baccalauréat, Certificat, Majeure/Mineure)", en: "1st cycle (Bachelor, Certificate, Major/Minor)" },
              { value: "2e cycle (Maîtrise, DESS, Microprogramme)", fr: "2e cycle (Maîtrise, DESS, Microprogramme)", en: "2nd cycle (Master, DESS, Microprogram)" },
              { value: "3e cycle (Doctorat / Ph.D.)", fr: "3e cycle (Doctorat / Ph.D.)", en: "3rd cycle (Doctorate / Ph.D.)" },
              { value: "Postdoctorat (Stagiaire postdoctoral)", fr: "Postdoctorat (Stagiaire postdoctoral)", en: "Postdoctorate (Postdoctoral fellow)" },
              { value: "autre", fr: "Autre (Saisie manuelle)", en: "Other (manual entry)" },
            ],
          },
          {
            name: "cycle_autre", type: "text", required: true, colSpan: 2,
            fr: "Précisez votre type d'études / statut particulier", en: "Specify your type of studies / particular status",
            showIf: { field: "cycle", value: "autre" },
          },
          {
            name: "inscription", type: "radio", fr: "Inscription", en: "Enrolment", required: true,
            options: [
              { value: "temps_plein", fr: "Temps plein", en: "Full time" },
              { value: "temps_partiel", fr: "Temps partiel", en: "Part time" },
            ],
          },
        ],
      },
      {
        fr: "Statut", en: "Status",
        fields: [
          {
            name: "statut_legal", type: "radio", fr: "Statut légal", en: "Legal status", colSpan: 2,
            options: [
              { value: "citoyen", fr: "Citoyen.ne canadien.ne", en: "Canadian citizen" },
              { value: "resident", fr: "Résident.e permanent.e", en: "Permanent resident" },
              { value: "etranger", fr: "Étudiant.e étranger.ère", en: "International student" },
              { value: "autre", fr: "Autre", en: "Other" },
            ],
          },
          {
            name: "situation_familiale", type: "radio", fr: "Situation matrimoniale", en: "Marital status", colSpan: 2,
            options: [
              { value: "celibataire", fr: "Célibataire", en: "Single" },
              { value: "marie", fr: "Marié.e", en: "Married" },
              { value: "conjoint_fait", fr: "Conjoint.e de fait", en: "Common-law" },
              { value: "divorce", fr: "Divorcé.e", en: "Divorced" },
            ],
          },
          { name: "enfants_charge", type: "yesno", fr: "Avez-vous des enfants à charge ?", en: "Do you have dependent children?" },
          { name: "habite_parents", type: "yesno", fr: "Habitez-vous chez vos parents ?", en: "Do you live with your parents?" },
        ],
      },
    ],
  },
  {
    number: 2,
    fr: "Ressources financières",
    en: "Financial resources",
    groups: [
      {
        fr: "Revenus et ressources (préciser les montants)", en: "Income and resources (specify amounts)",
        fields: [
          { name: "bourse_etudes_annuelle", type: "number", prefix: "$", fr: "Bourse d'études annuelle", en: "Annual study scholarship" },
          { name: "contribution_parents", type: "number", prefix: "$", fr: "Contribution réelle des parents", en: "Actual parental contribution" },
          { name: "contribution_conjoint", type: "number", prefix: "$", fr: "Contribution réelle du conjoint/autre", en: "Actual spouse/other contribution" },
          { name: "autres_revenus", type: "number", prefix: "$", fr: "Autres revenus (aide gouv., assurance-emploi, etc.)", en: "Other income (gov. aid, EI, etc.)" },
          { name: "autres_ressources", type: "number", prefix: "$", fr: "Autres ressources (économies, placements)", en: "Other resources (savings, investments)" },
        ],
      },
      {
        fr: "Situation", en: "Situation",
        fields: [
          { name: "prets_bourses", type: "yesno", fr: "Avez-vous des prêts et bourses ?", en: "Do you have loans and bursaries?" },
          { name: "exemption_frais", type: "yesno", fr: "Une exemption de frais ?", en: "A fee exemption?" },
          { name: "emploi_campus", type: "yesno", fr: "Un emploi sur le campus ?", en: "A job on campus?" },
          { name: "emploi_hors_campus", type: "yesno", fr: "Un emploi hors campus ?", en: "A job off campus?" },
        ],
      },
      {
        fr: "Emplois", en: "Employment",
        fields: [
          { name: "emplois_occupes", type: "textarea", fr: "Énumérer les emplois occupés", en: "List jobs held", colSpan: 2 },
          { name: "heures_travail_semaine", type: "number", required: true, fr: "Heures de travail par semaine (tous emplois)", en: "Work hours per week (all jobs)" },
          { name: "revenus_mensuels", type: "number", prefix: "$", fr: "Revenus mensuels associés", en: "Associated monthly income" },
          { name: "revenus_annuels", type: "number", prefix: "$", fr: "Revenus annuels totaux", en: "Total annual income" },
        ],
      },
    ],
  },
  {
    number: 3,
    fr: "Dépenses",
    en: "Expenses",
    groups: [
      {
        fr: "Frais scolaires", en: "School fees",
        fields: [
          { name: "droits_scolarite", type: "number", prefix: "$", fr: "Droits de scolarité", en: "Tuition fees", required: true },
          { name: "reste_scolarite", type: "number", prefix: "$", required: true, fr: "Reste à payer pour les frais de scolarité", en: "Tuition fees remaining to pay" },
          { name: "materiel_scolaire", type: "number", prefix: "$", fr: "Matériel scolaire", en: "School supplies" },
          { name: "assurance_maladie", type: "number", prefix: "$", fr: "Assurance maladie", en: "Health insurance" },
        ],
      },
      {
        fr: "Hébergement (mensuel)", en: "Housing (monthly)",
        fields: [
          { name: "loyer_pension", type: "number", prefix: "$", fr: "Loyer / pension", en: "Rent / board" },
          { name: "hypotheque", type: "number", prefix: "$", fr: "Hypothèque", en: "Mortgage" },
          { name: "taxes_assurances", type: "number", prefix: "$", fr: "Taxes / assurances", en: "Taxes / insurance" },
          { name: "chauffage_electricite", type: "number", prefix: "$", fr: "Chauffage / électricité", en: "Heating / electricity" },
          { name: "telecoms", type: "number", prefix: "$", fr: "Télécoms (Internet, cellulaire)", en: "Telecom (Internet, mobile)" },
        ],
      },
      {
        fr: "Nourriture (mensuel)", en: "Food (monthly)",
        fields: [
          { name: "epicerie", type: "number", prefix: "$", fr: "Épicerie", en: "Groceries" },
          { name: "repas_exterieur", type: "number", prefix: "$", fr: "Repas à l'extérieur", en: "Meals out" },
        ],
      },
      {
        fr: "Transport (mensuel)", en: "Transport (monthly)",
        fields: [
          { name: "transport_commun", type: "number", prefix: "$", fr: "Transport en commun / taxi", en: "Public transit / taxi" },
          { name: "auto_paiements", type: "number", prefix: "$", fr: "Auto (paiements)", en: "Car (payments)" },
          { name: "essence_reparations", type: "number", prefix: "$", fr: "Essence / réparations / assurance", en: "Gas / repairs / insurance" },
          { name: "stationnement", type: "number", prefix: "$", fr: "Stationnement", en: "Parking" },
        ],
      },
      {
        fr: "Santé (mensuel)", en: "Health (monthly)",
        fields: [
          { name: "sante_professionnels", type: "number", prefix: "$", fr: "Professionnels", en: "Professionals" },
          { name: "sante_assurance", type: "number", prefix: "$", fr: "Frais d'assurance", en: "Insurance fees" },
          { name: "prescriptions", type: "number", prefix: "$", fr: "Prescriptions non couvertes", en: "Uncovered prescriptions" },
          { name: "ortheses_visuelles", type: "number", prefix: "$", fr: "Orthèses visuelles", en: "Vision aids" },
          { name: "soins_personnels", type: "number", prefix: "$", fr: "Soins personnels", en: "Personal care" },
        ],
      },
      {
        fr: "Autres (mensuel)", en: "Other (monthly)",
        fields: [
          { name: "sports_loisirs", type: "number", prefix: "$", fr: "Sports / loisirs", en: "Sports / leisure" },
          { name: "divers_vetements", type: "number", prefix: "$", fr: "Divers (vêtements)", en: "Misc. (clothing)" },
          { name: "frais_garde", type: "number", prefix: "$", fr: "Frais de garde d'enfants", en: "Childcare fees" },
          { name: "depenses_exceptionnelles", type: "number", prefix: "$", fr: "Dépenses exceptionnelles prévues", en: "Planned exceptional expenses" },
          { name: "depenses_exceptionnelles_precisions", type: "textarea", fr: "Précisions sur les dépenses exceptionnelles", en: "Details on exceptional expenses", colSpan: 2 },
        ],
      },
      {
        fr: "Endettement (mensuel)", en: "Debt (monthly)",
        fields: [
          { name: "pret_cartes_marge", type: "number", prefix: "$", fr: "Prêt / cartes / marge de crédit", en: "Loan / cards / line of credit" },
          { name: "prets_autres_gouv", type: "number", prefix: "$", fr: "Prêts autres que gouvernementaux", en: "Non-governmental loans" },
        ],
      },
    ],
  },
  {
    number: 4,
    fr: "Lettre de présentation & Démarches",
    en: "Cover letter & Steps taken",
    groups: [
      {
        fr: "Votre situation", en: "Your situation",
        fields: [
          { name: "lettre_presentation", type: "textarea", rows: 8, required: true, colSpan: 2,
            fr: "Lettre de présentation de votre demande", en: "Cover letter for your application",
            helpFr: "Expliquez en quoi vous êtes en situation de précarité financière.",
            helpEn: "Explain how you are in a situation of financial precarity." },
          { name: "demarches_revenus", type: "textarea", rows: 4, colSpan: 2,
            fr: "Démarches entreprises pour augmenter les revenus", en: "Steps taken to increase income" },
          { name: "demarches_depenses", type: "textarea", rows: 4, colSpan: 2,
            fr: "Démarches entreprises pour diminuer les dépenses", en: "Steps taken to reduce expenses" },
          { name: "commentaires", type: "textarea", rows: 4, colSpan: 2,
            fr: "Commentaires additionnels (optionnel)", en: "Additional comments (optional)" },
        ],
      },
    ],
  },
];

export const NUMERIC_FIELDS = [
  "bourse_etudes_annuelle", "contribution_parents", "contribution_conjoint", "autres_revenus", "autres_ressources",
  "heures_travail_semaine", "revenus_mensuels", "revenus_annuels",
  "droits_scolarite", "reste_scolarite", "materiel_scolaire", "assurance_maladie", "loyer_pension", "hypotheque", "taxes_assurances",
  "chauffage_electricite", "telecoms", "epicerie", "repas_exterieur", "transport_commun", "auto_paiements",
  "essence_reparations", "stationnement", "sante_professionnels", "sante_assurance", "prescriptions",
  "ortheses_visuelles", "soins_personnels", "sports_loisirs", "divers_vetements", "depenses_exceptionnelles",
  "frais_garde", "pret_cartes_marge", "prets_autres_gouv",
];

export const EXPENSE_FIELDS = [
  "droits_scolarite", "materiel_scolaire", "assurance_maladie", "loyer_pension", "hypotheque", "taxes_assurances",
  "chauffage_electricite", "telecoms", "epicerie", "repas_exterieur", "transport_commun", "auto_paiements",
  "essence_reparations", "stationnement", "sante_professionnels", "sante_assurance", "prescriptions",
  "ortheses_visuelles", "soins_personnels", "sports_loisirs", "divers_vetements", "depenses_exceptionnelles",
  "frais_garde", "pret_cartes_marge", "prets_autres_gouv",
];

export const BOOLEAN_FIELDS = [
  "enfants_charge", "habite_parents",
  "prets_bourses", "exemption_frais", "emploi_campus", "emploi_hors_campus",
];
